module.exports = __webpack_public_path__ + "media/images/common/navbar_logo_white-d57a6630ee8d9714bffcf797971e2fad.png";